import React, { useEffect, useState, constructor } from 'react';
import { Row, Col, Card, Space, DatePicker, Drawer, Form, Input, Select, Radio, message, Modal, Pagination } from 'antd';
import { Table, Button } from 'antd';
import BreadcrumbCustom from '../../components/widget/BreadcrumbCustom';
import { DownOutlined, ExclamationCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { ITeachClassStudent, listTeachClassStudents, createTeachClassStudent, deleteTeachClassStudent } from '../../service/api/teachClass';
import { IStudent, listStudentsByStoreId } from '../../service/api/student';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { FormInstance } from 'antd/lib/form/Form';
const { confirm } = Modal;
const { Option } = Select;
// import queryString from 'query-string';

// const values = queryString.parse(window.location.search)

function getUrlParam(name: string, str: string) {
  const paramUrl = str.split('?');
  const params = paramUrl[1].split('&');
  for (var i = 0; i < params.length; i++) {
    const value = params[i].split('=');
    if (value[0] == name) {
      return value[1];
    }
  }
  return null;
}

const TeachClassStudentView = (props: any) => {
  const [teachClassStudents, setTeachClassStudents] = useState<IStudent[]>();
  const [teachClassStudentDetail, setTeachClassStudentDetail] = useState<ITeachClassStudent>();
  const [teachClassStudentVisible, setTeachClassStudentVisible] = useState(false);
  const [students, setStudents] = useState<IStudent[]>();
  const [teachClassId, setTeachClassId] = useState<any>();
  const [storeId, setStoreId] = useState<any>();
  const [pageNum, setPageNum] = useState(1);
  const [pageTotal, setPageTotal] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [loading, setLoading] = useState(false);
  const formRef = React.createRef<FormInstance>();
  const columns = [
    {
      title: '学号',
      dataIndex: 'num',
      key: 'num',
    },
    {
      title: '姓名',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: '性别',
      dataIndex: 'sex',
      key: 'sex',
      render: (text: any, record: any) => {
        if (record.sex == 1) {
          return '男'
        } else {
          return '女'
        }
      }
    },
    {
      title: '所属门店',
      dataIndex: 'storeName',
      key: 'storeName',
    },
    {
      title: '最后打卡记录',
      dataIndex: 'lastPunchTime',
      key: 'lastPunchTime',
      render(val: Date) {
        return val ? moment(val).format('YYYY-MM-DD HH:mm') : <>&mdash;</>
      },
    },
    {
      title: '课程信息',
      dataIndex: 'courseMessage',
      key: 'courseMessage',
      render(val: Date) {
        return val ? val : <>&mdash;</>
      },
    },
    {
      title: '备注',
      dataIndex: 'remark',
      key: 'remark',
    },
    {
      title: '操作',
      key: 'action',
      render: (text: any, record: any) => (
        <Space size="middle">
          <a onClick={e => { onDelete(e, record) }}>移除 </a>
        </Space>
      ),
    }
  ];

  useEffect(() => {
    loadData();
  }, [pageNum, pageSize]);

  useEffect(() => {
    if (teachClassStudentDetail) {
      let copyFormData = JSON.parse(JSON.stringify(teachClassStudentDetail))
      // 设置100毫秒的延迟 确保from组件已经加载完毕
      setTimeout(() => {
        formRef.current!.setFieldsValue(copyFormData);
      }, 100);
    }
  }, [teachClassStudentDetail]);

  const loadData = () => {
    setTeachClassId(getUrlParam('teachClassId', window.location.href));
    setStoreId(getUrlParam('storeId', window.location.href));
    console.log('csn:' + getUrlParam('teachClassId', window.location.href));
    listTeachClassStudents(getUrlParam('teachClassId', window.location.href)).then((info: any) => {
      setTeachClassStudents(info?.data);
      // console.log("info:" + JSON.stringify(info.data));
    });
    listStudentsByStoreId(getUrlParam('storeId', window.location.href)).then((info: any) => {
      setStudents(info?.data);
    });
  }

  const onFinish = (values: any) => {
    setLoading(true);
    if (teachClassStudentDetail) {
      // updateStudent({
      //   ...values,
      //   id: teachClassStudentDetail.id
      // }).then((info: any) => {
      //   console.log("info:" + JSON.stringify(info));
      //   message.success("更新成功");
      //   onClose();
      //   loadData();
      // });
    } else {
      createTeachClassStudent({
        ...values,
        teachClassId: teachClassId
      }).then((info: any) => {
        console.log("info:" + JSON.stringify(info));
        if (info) {
          message.success("创建成功");
          onClose();
          setLoading(false);
          loadData();
        }
      });
    }
  };

  const onDelete = (e: any, item: IStudent) => {
    e.stopPropagation();
    confirm({
      title: '提示',
      icon: <ExclamationCircleOutlined />,
      content: '确定要删除该班级学员吗？删除后无法恢复',
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      onOk() {
        deleteTeachClassStudent(item.id, teachClassId).then((info: any) => {
          if (info) {
            console.log("info:" + JSON.stringify(info));
            message.success("删除成功");
            loadData();
          }
        });
      },
      onCancel() {
      },
    });
  }

  const onClose = () => {
    setTeachClassStudentDetail(undefined);
    setTeachClassStudentVisible(false);
    if (formRef.current) {
      formRef.current!.resetFields();
    }
  }

  // 下拉框值
  const studentOptions = students?.map((student) =>
    <Option key={student.id} value={student.id}>{student.name}</Option>);


  return (
    <div className="gutter-example">
      <BreadcrumbCustom breads={[<Link to={'/app/schedule'}>排课管理</Link>, <Link to={'/app/schedule?index=2'}>班级管理</Link>, '班级学员']} />
      <Row gutter={16}>
        <Col className="gutter-row" md={24}>
          <div className="gutter-box">
            <Card title={decodeURI(getUrlParam('teachClassName', window.location.href)!)} bordered={false} extra={
              <Button type="primary" onClick={() => {
                setTeachClassStudentVisible(true);
              }} icon={<PlusOutlined />}>
                新增
              </Button>
            }>
              <Table dataSource={teachClassStudents} columns={columns} pagination={false} />
            </Card>
          </div>
        </Col>
      </Row>
      <Drawer
        title={teachClassStudentDetail ? "编辑班级学员" : "新增班级学员"}
        visible={teachClassStudentVisible}
        width={720}
        onClose={onClose}
        bodyStyle={{ paddingBottom: 80 }}
        destroyOnClose
      >
        <Form onFinish={onFinish} ref={formRef} layout="vertical" hideRequiredMark>
          <Row gutter={16}>
            <Col span={16}>
              <Form.Item
                name="studentIds"
                label="学员"
                rules={[{ required: true, message: '请选择要加入班级的学员' }]}
              >
                <Select
                  mode="multiple"
                  placeholder="请选择要加入班级的学员"
                  showSearch
                  filterOption={(input, option) =>
                    option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }>
                  {studentOptions}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item>
                <Button type="primary" htmlType="submit" loading={loading}>保存</Button>
                <Button htmlType="button" onClick={onClose}>取消</Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>
    </div>
  );
};

export default TeachClassStudentView;
